
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.148.269a.916.916 0 10-1.296 1.296l1.644 1.644-1.633 1.635-1.946-1.946a.916.916 0 00-1.296 0L5.5 10.018a1.821 1.821 0 00-.537 1.296c0 .49.19.95.536 1.297l-1.296 1.296a1.824 1.824 0 00-.537 1.297c0 .49.191.95.537 1.296l.002.002L.27 20.435a.916.916 0 001.295 1.297l3.938-3.934c.357.356.826.534 1.294.534.47 0 .939-.178 1.297-.536L9.389 16.5c.357.358.827.536 1.296.536.47 0 .94-.178 1.297-.536l2.015-2.015.016-.014c.006-.004.009-.01.014-.016l2.262-2.262.016-.013.014-.017 2.784-2.784a.917.917 0 000-1.296L17.16 6.141l1.633-1.636 1.643 1.643a.912.912 0 00.647.269.916.916 0 00.648-1.565L17.148.269zM6.796 16.499L5.5 15.205l1.296-1.297 1.297 1.297L6.796 16.5zm8.86-6.265l-.8-.799a.916.916 0 10-1.295 1.296l.798.8-.995.995-.799-.799a.916.916 0 10-1.296 1.296l.799.799-1.382 1.382-3.24-3.24-.001-.002h-.001l-.648-.648 6.473-6.472 1.938 1.938.008.01.01.007 1.933 1.933-1.503 1.504z","fill":"#8E8E92","fill-rule":"nonzero"}})])
          )
        }
      }
    